<template>
    <div
        :class="[
            'md-house',
            'grid-v2',
            'grid',
            'standard',
            morePosition === 'top' ? 'top-more' : ''
        ]"
        :style="{ paddingTop, marginBottom }"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div class="house-title" :class="title ? '' : 'no-title'">
                <div class="main-title">
                    <div
                        class="mg-title"
                        v-html="formatFontSize(title, '--mg-title-size')"
                    ></div>
                    <a
                        v-if="moreText && !isMobileSize"
                        class="mg-more"
                        :href="moreLink"
                        :aria-label="moreLinkPurpose"
                        :style="moreStyle"
                        rel="noopener noreferrer"
                    >
                        {{ moreText }}
                        <i class="iconfont icon-next"></i>
                    </a>
                </div>
                <div v-if="title && desc" class="desc" v-html="desc"></div>
            </div>
            <Grid :class="{ 'full-screen': fullColumn }" />
            <a
                v-if="moreText && isMobileSize"
                class="mg-more"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                :style="moreStyle"
                rel="noopener noreferrer"
            >
                {{ moreText }}
                <i class="iconfont icon-next"></i>
            </a>
            <MlsDesclaimer v-if="wordPressSSR" />
        </module-box>
    </div>
    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import Core from '../index';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    mixins: [Core],
    components: { 
        Grid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v2_grid"*/ './grid.vue'
            )),
    }
};
</script>
<style lang="scss">
.md-house.grid-v2 {
    .mg-title {
        padding-bottom: 0;
    }
    .desc {
        margin-top: 0;
    }
}
</style>
